import { DESC, Filters, List } from 'framework/list';
import LeadsListContent from 'domain/sales/lead/List/LeadsListContent';
import useLeadService from 'domain/sales/lead/shared/leadService';

const LeadsList = () => {
  const { search, getFilterValidationSchema } = useLeadService();

  return (
    <List getDataMethod={search} defaultSortField="updatedAt" defaultSortOrder={DESC}>
      <Filters getValidationSchema={getFilterValidationSchema}>
        <LeadsListContent />
      </Filters>
    </List>
  );
};

export default LeadsList;
